import React from 'react'

import Styles from "./adminSpectacles.module.scss";
import { Table, Button, Input, Form, FormGroup, Label, Container } from 'reactstrap';
import confirm from 'reactstrap-confirm';
import ISpectacle from 'model/spectacle';
import SpectaclesService from 'services/spectaclesService';
import IFileInfo from 'model/fileInfo';
import { isPicture } from 'components/common/fileExplorer/fileExplorer';
import FileFolderSelector from 'components/common/fileFolderSelector/fileFolderSelector';
import Editor from 'components/common/editor/editor';
interface IAdminSpectaclesProps {

}

interface IAdminSpectaclesState {
    spectacleEdition?: ISpectacle;
    spectacles: ISpectacle[];
    folders: IFileInfo[]
}

class AdminSpectacles extends React.Component<IAdminSpectaclesProps, IAdminSpectaclesState> {
    /**
     *
     */
    constructor(props: IAdminSpectaclesProps) {
        super(props);

        this.state = { spectacleEdition: undefined, spectacles: [], folders: [] };
    }


    componentDidMount() {
        this.load();
    }

    load() {
        Promise.all(
            [
                SpectaclesService.GetAllSpectacles(),
                SpectaclesService.GetPictureFolder()
            ]
        )
            .then(value => {
                this.setState({ spectacles: value[0].sort((a: ISpectacle, b: ISpectacle) => { return a.Id < b.Id ? -1 : 1 }), spectacleEdition: undefined, folders: value[1] });
            })
    }

    setSpectacleToEdit(spect: ISpectacle) {
        this.setState({ spectacleEdition: spect });
    }

    saveSpectacle(spect: ISpectacle) {
        SpectaclesService.SetSpectacle(spect).then(this.load.bind(this));
    }


    setSpectacleToDelete(spect: ISpectacle) {
        confirm({
            title: 'Suppression du spectacle',
            message: "Etes vous sûr de vouloir supprimer le spectacle ?",
            confirmText: "Supprimer",
            confirmColor: "primary",
            cancelColor: "danger"
        }).then((res: any) => {
            if (res) {
                return SpectaclesService.DeleteSpectacle(spect).then(this.load.bind(this));
            }
        });
    }

    render() {
        return <div className={Styles.AdminSpectacles}>
            <Container>

                <Button color="primary" onClick={this.setSpectacleToEdit.bind(this, {} as ISpectacle)}>Créer un spectacle</Button>
                <Table>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Titre</th>
                            <th>Editer</th>
                            <th>Supprimer</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.spectacles.map(s => {
                            return <tr key={s.Id} className={Styles.SpectacleRow}>
                                <th scope="row">{s.Id}</th>
                                <td>{s.Title}</td>
                                <td><Button color="primary" onClick={this.setSpectacleToEdit.bind(this, s)}>Editer</Button></td>
                                <td><Button color="danger" onClick={this.setSpectacleToDelete.bind(this, s)}>Supprimer</Button></td>
                            </tr>
                        })}
                    </tbody>

                </Table>
                {this.state.spectacleEdition ?

                    <div className={Styles.Edition}>
                        {this.state.spectacleEdition.Id ? <h2>Edition du spectacle {this.state.spectacleEdition.Id}</h2> : <h2>Création de spectacle</h2>}
                        <Form>
                            <FormGroup>
                                <Label for="inputTitle">Titre</Label>
                                <Input id="inputTitle" placeholder="Titre" value={this.state.spectacleEdition.Title} onChange={(newText) => {
                                    if (this.state.spectacleEdition)
                                        this.setState({ spectacleEdition: { ...this.state.spectacleEdition, Title: newText.target.value } })
                                }} />
                            </FormGroup>

                            <FormGroup>
                                <Label for="inputContent">Contenu</Label>
                                <Editor onChange={(newText) => {
                                    if (this.state.spectacleEdition)
                                        this.setState({ spectacleEdition: { ...this.state.spectacleEdition, Content: newText.target.getContentAreaContainer().innerHTML } })

                                }
                                } initialValue={this.state.spectacleEdition.Content} />


                            </FormGroup>
                            <FormGroup>
                                <Label for="inputPictureUrl">Image principale</Label>
                                <FileFolderSelector filter={isPicture} onSelect={this.saveChangeMainPicture.bind(this)} value={this.state.spectacleEdition.MainPictureUrl} />
                            </FormGroup>
                            <FormGroup>
                                <Label for="inputPictureFolder">Dossier d'images</Label>
                                <FileFolderSelector folder onSelect={this.saveChangeFolder.bind(this)} value={this.state.spectacleEdition.PictureFolder} />

                            </FormGroup>
                        </Form>
                        <Button color="primary" onClick={this.saveSpectacle.bind(this, this.state.spectacleEdition)}>Sauvegarder</Button>
                        <Button color="danger" onClick={() => this.setState({ spectacleEdition: undefined })}>Annuler</Button>
                    </div>
                    : null
                }
            </Container>
        </div>
    }


    saveChangeFolder(value: string) {
        if (this.state.spectacleEdition)
            this.setState({ spectacleEdition: { ...this.state.spectacleEdition, PictureFolder: value } });
    }


    saveChangeMainPicture(value: string) {
        if (this.state.spectacleEdition)
            this.setState({ spectacleEdition: { ...this.state.spectacleEdition, MainPictureUrl: value } });
    }

}

export default AdminSpectacles;